module.exports = __webpack_public_path__ + "img/twitter.13b317d6.png";